import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "formResponses";

const loadFromLocalStorage = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

const saveToLocalStorage = (responses) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(responses));
};

const initialState = {
  responses: loadFromLocalStorage(),
};

const formResponsesSlice = createSlice({
  name: "formResponses",
  initialState,
  reducers: {
    addResponse: (state, action) => {
      state.responses.push(action.payload);
      saveToLocalStorage(state.responses);
    },
    clearResponsesForForm: (state, action) => {
      state.responses = state.responses.filter(
        (res) => res.formId !== action.payload
      );
      saveToLocalStorage(state.responses);
    },
    clearAllResponses: (state) => {
      state.responses = [];
      saveToLocalStorage([]);
    },
  },
});

export const { addResponse, clearResponsesForForm, clearAllResponses } =
  formResponsesSlice.actions;
export default formResponsesSlice.reducer;
